export default __webpack_public_path__ + "static/media/strategic-planning.a66ce65a.jpg";